import styled from "styled-components";

import { theme } from "../../../styles/theme";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: ${theme.font.poppins};

  @media screen and (max-width: 768px) {
    justify-content: flex-start;
  }
`;

export const Title = styled.h1`
  font-size: ${theme.font.sizes.medium};
  font-weight: ${theme.font.bold};
  color: ${theme.colors.blue100};
  text-align: center;

  @media screen and (max-width: 768px) {
    margin-top: 50px;
  }
`;

export const CardContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  justify-content: center;
  gap: 2rem;
  margin-top: 4rem;
  & > * {
    justify-self: center;
    max-width: 70%;
  }

  @media screen and (min-width: 992px) {
    grid-template-columns: 1fr 1fr;

    & > :first-child {
      justify-self: end;
    }

    & > :last-child {
      justify-self: start;
    }
  }
`;
